// 绩效模式
import request from '@/utils/request'
// /bsPerformanceMode/{id}
// 查询
export function queryById(id) {
  return request({
    url: '/bsPerformanceMode/' + id,
    method: 'get',
  })
}
// 添加
export function add(data) {
  return request({
    url: '/bsPerformanceMode/save',
    method: 'post',
    data
  })
}

// /bsPerformanceMode/delete/{id}
// 删除
export function del(id) {
  return request({
    url: '/bsPerformanceMode/delete/' + id,
    method: 'delete'
  })
}

// /bsPerformanceMode/update
// 修改
export function edit(data) {
  return request({
    url: '/bsPerformanceMode/update',
    method: 'put',
    data
  })
}

// /bsPerformanceComposition/delete/{id} 绩效组成 删除
export function delBsPerformance(id) {
  return request({
    url: '/bsPerformanceComposition/delete/' + id,
    method: 'delete'
  })
}
